// API Configuration
const isDevelopment = process.env.NODE_ENV === 'development';
export const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8000'  // Development
  : 'https://atlas.rest';    // Production

// S3 Configuration
export const S3_RESTAURANT_PLACEHOLDER = process.env.REACT_APP_S3_RESTAURANT_PLACEHOLDER || 'https://atlasrest.fra1.cdn.digitaloceanspaces.com/placeholder-rest.svg';
export const S3_DISH_PLACEHOLDER = process.env.REACT_APP_S3_DISH_PLACEHOLDER || 'https://atlasrest.fra1.cdn.digitaloceanspaces.com/placeholder-dish.svg'; 